// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__26CkF","colMaxWidth":"Table_colMaxWidth__396qF"};